import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement>

export function TurboPickupLightningIcon({
  width = 12,
  height = 15,
  ...props
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.56689 0.566711L0.566895 8.56671H5.23356L4.56689 13.9L10.5669 5.90004H5.90023L6.56689 0.566711Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.13333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
